import {
  AccountDetailInfo,
  Bot,
  MarketSecurityProps,
  MarketView,
  TimeFramePresets,
  TimeSlices,
} from "./types";
import { PositionBehaviour, Strategy, TimeFrame } from "../store/slices/strategySlice";
import { Theme } from "@mui/material/styles";

export const _API_ = "/api/public";

export const SERVER_URL = "/todos";
export const APP_ID = "_adron-test";

// HTTP-методы
export const POST = "POST";
export const DELETE = "DELETE";
export const PUT = "PUT";

// Операции
export const UPDATE = "UPDATE";
export const REMOVE = "REMOVE";

export const PADDING_AFTER_HEADER = 11;
export const PADDING_AFTER_HEADER_SMALLER = 9;

export const BADGE_PAPER_STYLES = {
  paddingLeft: "10px",
  paddingRight: "10px",
  display: "flex",
  alignItems: "center",
  height: "20px",
  whiteSpace: "nowrap",
};

export function IconButtonStyled(theme: Theme) {
  return {
    backgroundColor: theme.palette.secondary.main + "!important",
    width: 40,
    height: 40,
    borderRadius: "12px !important",
  };
}

export const TG_DATA =
  'user={"id":299060651,"first_name":"Денис","last_name":"Прокопенков","username":"denis_prokopenkoff","language_code":"ru","is_premium":true,"allows_write_to_pm":true,"photo_url":"https:\\/\\/t.me\\/i\\/userpic\\/320\\/MAn6B2fQWRCEDFFaZlKv3RlbLlg_sobS8p5qdwdNegs.svg"}&chat_instance=-3316607888532270807&chat_type=sender&auth_date=1742302289&signature=9RNfV_G6un5ne-WOk71JeKdH48nsGZClBATO0RmwLzGad5VL2s_5tNnmulN5Vf7FyYlp4LdHnU4F80uvJH1gBw&hash=85545d30c778b70e69b4b57a05b817e325258031939ee9ca47e79e978418c46b';

export const NBSP = "\u00A0";

// bot defaults, calculates
export const GRID_AMOUNT = 10;
export const INCREASE = 1.2;
export const DECREASE = 0.8;

export const INIT_STATE_ACCOUNT_DETAIL: AccountDetailInfo = {
  id: "",
  name: "",
  profileId: "",
  market: "",
  marginType: "",
  leverage: 0,
  linkDatetime: "",
};

export const INIT_STATE_BOT: Bot = {
  id: "",
  displayedId: "",
  accountName: "",
  quote: "USDT",
  base: "",
  direction: "",
  stepsCount: 0,
  leverage: 1,
  investment: 1000,
  pnl: 0,
  totalProfit: 0,
  pnlPercentage: 0,
  total: 0,
  roi: 0,
  initialAmountQuote: 0,
  runtime: 0,
  minPrice: 0,
  priceStepPrecision: 0,
  botType: "FUTURES_GRID",
  maxPrice: 0,
  grids: 10,
  startPrice: 0,
  gridStepType: "ARITHMETIC",
  profitPerGrid: 0,
  status: undefined,
  gridDirection: "Central",
  totalInvestment: 10000,
  createdAt: "",
  currencyType: "QUOTE",
  accountId: "",
  gridsAmount: 10,
  gridType: "ARITHMETIC",
  priceStep: 100,
  gridsCompleted: 0,
  allGridsProfit: 0,
  totalFees: 0,
  realizedProfit: 0,
  unrealizedPnl: 0,
  apr: 0,
  isAutoManaged: false,
  currentPosition: "",
  currentPositionQuote: 0,
  currentPositionBase: 0,
  startedAt: "",
  outOfRange: false,
  closedAt: "",
  closeTime: "",
  margin: 0,
  ticker: {
    id: "",
    base: "",
    quote: "",
    orderStep: 0,
    priceStep: 0,
    minNotional: -1,
  },
  priceStepQuote: 0,
  priceStepPercentage: "",
  customGridSettings: [],
  avgPositionOpeningPrice: 0,
  errorCode: undefined,
  timeframe: undefined,
  customHighPrice: 0,
  customLowPrice: 0,
  orderAmount: 0,
};

export const INIT_STATE_STRATEGY: Strategy = {
  id: "",
  displayedId: "",
  base: "",
  quote: "",
  ticker: {
    id: "",
    base: "",
    quote: "",
    orderStep: 0,
    priceStep: 0,
    minNotional: -1,
  },
  accountId: "",
  profileId: "",
  startPrice: 0,
  currencyType: "QUOTE",
  investment: 100,
  investmentQuote: 100,
  requiredMargin: 0,
  minPrice: 0,
  maxPrice: 0,
  leverage: 1,
  stepsCount: 0,
  gridDirection: "Long",
  timeframes: [],
  customFrame: false,
  gridProfit: 0,
  fees: 0,
  fundingPnl: 0,
  realizedPnl: 0,
  unrealizedPnl: 0,
  currentOpenPositionAmount: 0,
  avgPositionOpeningPrice: 0,
  closeTime: "",
  marketType: "",
  status: undefined,
  createdAt: "",
  presetType: "SHORT_TERM",
  runtimeHours: 0,
  strategyPositionRealizedPnl: 0,
  strategyPositionFees: 0,
  totalCurrentPositionAmount: 0,
  totalPositionAvgPrice: 0,
  totalRealizedPnl: 0,
  totalFees: 0,
  unrealizedStrategyPositionPnl: 0,
  totalUnrealizedPnl: 0,
  currentStrategyPositionAmount: 0,
  avgStrategyPositionPrice: 0,
  startTime: "",
  apr: 0,
  positionBehaviour: "Both",
};

export const route = {
  root: "/",
  onboarding: "/onboarding",
  secured: "/secured",
  bots: "/bots",
  botsList: "/bots/list/:type",
  botDetail: "/bots/list/:type/:id",
  strategyList: "/strategy/list/:type",
  strategyDetail: "strategy/list/:type/:id",
  dashboard: "/dashboard",
  choosePair: "/choosepair/:entity",
  creation: "/creation/:entity",
  creationBot: "/creation/bot",
  creationStrategy: "/creation/strategy",
  advancedGrid: "/advancedgrid",
  notifications: "/notifications/",
  leaderboard: "/leaderboard",
  profile: "/profile",
  profileAccount: "/profile/account/",
  profileAppearance: "/profile/appearence/",
  profileLanguage: "/profile/language/",
  profileAbout: "/profile/about/",
  profileNotifications: "/profile/notifications/",
  account: {
    add: "/account/add",
    connect: "/account/connect/:market",
    settings: "/account/settings/:accountId",
  },
  subscription: "/subscription/",
};

export const NO_NAV_BAR_PAGES = [
  "/creation",
  "/bots/list/",
  "/choosepair",
  "/account/add",
  "/account/connect",
  "/account/settings",
  "/strategy/list",
  "/notifications",
  "/subscription",
  "/onboarding",
];

export const TG_PLATFORMS = ["web", "android", "macos", "tdesktop", "ios", "unknown"];

export const markets: MarketView[] = [
  { name: "BINANCE", displayedName: "BINANCE" },
  { name: "BYBIT", displayedName: "Bybit" },
  { name: "AEVO", displayedName: "Aevo" },
  { name: "OKX", displayedName: "OKX" },
  { name: "REYA_DEX", displayedName: "Reya-Dex" },
];

export const marketsDictionary: { [key: string]: MarketView } = {
  BINANCE: { name: "BINANCE", displayedName: "BINANCE" },
  BYBIT: { name: "BYBIT", displayedName: "Bybit" },
  AEVO: { name: "AEVO", displayedName: "Aevo" },
  OKX: { name: "OKX", displayedName: "OKX" },
  REYA_DEX: { name: "REYA_DEX", displayedName: "Reya-Dex" },
};

export const PRINT_TIME_SLICE = {
  FIVE_MINUTES: "5 min",
  FIFTEEN_MINUTES: "15 min",
  THIRTY_MINUTES: "30 min",
  ONE_HOUR: "1 hour",
  TWO_HOURS: "2 hours",
  FOUR_HOURS: "4 hours",
  SIX_HOURS: "6 hours",
  EIGHT_HOURS: "8 hours",
  TWELVE_HOURS: "12 hours",
  ONE_DAY: "1 day",
};

export const TimeFramesShort: TimeFrame[] = [
  {
    checked: true,
    interval: TimeSlices.FIVE_MINUTES,
    assignedVolume: 0.3333,
    profitPercent: -1,
  },
  {
    checked: true,
    interval: TimeSlices.FIFTEEN_MINUTES,
    assignedVolume: 0.3333,
    profitPercent: -1,
  },
  {
    checked: true,
    interval: TimeSlices.THIRTY_MINUTES,
    assignedVolume: 0.3334,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.ONE_HOUR,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.TWO_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.FOUR_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.SIX_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.EIGHT_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.TWELVE_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.ONE_DAY,
    assignedVolume: 0,
    profitPercent: -1,
  },
];

export const TimeFramesMiddle: TimeFrame[] = [
  {
    checked: false,
    interval: TimeSlices.FIVE_MINUTES,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: true,
    interval: TimeSlices.FIFTEEN_MINUTES,
    assignedVolume: 0.3333,
    profitPercent: -1,
  },
  {
    checked: true,
    interval: TimeSlices.THIRTY_MINUTES,
    assignedVolume: 0.3333,
    profitPercent: -1,
  },
  {
    checked: true,
    interval: TimeSlices.ONE_HOUR,
    assignedVolume: 0.3334,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.TWO_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.FOUR_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.SIX_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.EIGHT_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.TWELVE_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.ONE_DAY,
    assignedVolume: 0,
    profitPercent: -1,
  },
];

export const TimeFramesLong: TimeFrame[] = [
  {
    checked: false,
    interval: TimeSlices.FIVE_MINUTES,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.FIFTEEN_MINUTES,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: true,
    interval: TimeSlices.THIRTY_MINUTES,
    assignedVolume: 0.25,
    profitPercent: -1,
  },
  {
    checked: true,
    interval: TimeSlices.ONE_HOUR,
    assignedVolume: 0.25,
    profitPercent: -1,
  },
  {
    checked: true,
    interval: TimeSlices.TWO_HOURS,
    assignedVolume: 0.25,
    profitPercent: -1,
  },
  {
    checked: true,
    interval: TimeSlices.FOUR_HOURS,
    assignedVolume: 0.25,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.SIX_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.EIGHT_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.TWELVE_HOURS,
    assignedVolume: 0,
    profitPercent: -1,
  },
  {
    checked: false,
    interval: TimeSlices.ONE_DAY,
    assignedVolume: 0,
    profitPercent: -1,
  },
];

export const TIME_FRAME_PRESETS: TimeFramePresets = {
  Short: TimeFramesShort,
  Mid: TimeFramesMiddle,
  Long: TimeFramesLong,
};

export const TimeExchangeIntervals = {
  "1": "1m",
  "3": "3m",
  "5": "5m",
  "15": "15m",
  "30": "30m",
  "60": "1h",
  "120": "2h",
  "240": "4h",
  "360": "6h",
  "480": "8h",
  "720": "12h",
  D: "1d",
  "1D": "1d",
  "3D": "3d",
  W: "1w",
  "1W": "1w",
  M: "1M",
  "1M": "1M",
};

export const TimeExchangeIntervalsBybit = {
  "1": "1",
  "3": "3",
  "5": "5",
  "15": "15",
  "30": "30",
  "60": "60",
  "120": "120",
  "240": "240",
  "360": "360",
  "480": "480",
  "720": "720",
  D: "D",
  "1D": "1D",
  "3D": "3D",
  W: "W",
  "1W": "1W",
  M: "M",
  "1M": "1M",
};
